/**
 * H4 (decisions.md §34): the Terms of use and Privacy notice. The text lives in
 * `messages/en.json` + `hi.json` (`legal.terms.*`, `legal.privacy.*`). Whether a school's text is
 * still a DRAFT is that school's data (`tenant_settings`, via the bootstrap `termsDraft`), set by
 * the platform admin; while it is, both pages show the banner naming the school.
 */

/** The sections of each page, in order: each has `<id>Title` and `<id>Body` keys. */
export const TERMS_SECTIONS = ["account", "content", "sharing", "devices", "changes", "contact"];
export const PRIVACY_SECTIONS = ["recorded", "why", "retention", "who", "other", "rights"];

export type LegalDocument = "terms" | "privacy";

export function legalPath(tenantSlug: string, doc: LegalDocument): string {
  return `/t/${tenantSlug}/${doc}`;
}
